import script from "./DictionaryRooms.vue?vue&type=script&lang=ts&setup=true"
export * from "./DictionaryRooms.vue?vue&type=script&lang=ts&setup=true"

import "./DictionaryRooms.vue?vue&type=style&index=0&id=5ae9d8ed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae9d8ed"]])

export default __exports__